<template>
    <div>
        <el-row>
            <!--add new report button-->
            <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="handleOpenAddModal"
            >
                Add
            </el-button>
            <!--add report modal-->
            <el-dialog
                    title="Create Capacity Report"
                    :visible.sync="showAddModal"
                    top="10vh"
                    :center="true"
            >
                <el-form
                        ref="form"
                        :model="form"
                        label-width="15%"
                >
                    <el-form-item label="Origin" prop="placeOriginId">
                        <el-select
                                class="el-form-item-inside"
                                v-model="form.placeOriginId"
                                placeholder="Please select origin place"
                                filterable
                        >
                            <el-option
                                    v-for="place in places"
                                    :label="place.name"
                                    :key="place.id"
                                    :value="place.id"
                            >
                                <span>{{place.name}}</span>
                                <span style="float:right;color:#ccc">{{place.address_readable}}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Destination" prop="placeDestinationId">
                        <el-select
                                class="el-form-item-inside"
                                v-model="form.placeDestinationId"
                                placeholder="Please select destination place"
                                filterable
                        >
                            <el-option
                                    v-for="place in places"
                                    :label="place.name"
                                    :key="place.id"
                                    :value="place.id"
                            >
                                <span>{{place.name}}</span>
                                <span style="float:right;color:#ccc">{{place.address_readable}}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Time" prop="time">
                        <el-date-picker
                                class="el-form-item-inside"
                                v-model="form.time"
                                type="daterange"
                                start-placeholder="Start"
                                end-placeholder="End"
                                :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>

                    <!--Form Buttons-->
                    <el-form-item>
                        <el-button type="primary" @click="handleSubmit('form')" :loading="isAddingJourneyRequest">Create</el-button>
                        <el-button @click="handleReset('form')">Reset</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
            <!--generate utilisation chart button-->
            <el-button
                    type="success"
                    icon="el-icon-s-data"
                    :disabled = '! canGenerateChart'
                    @click="handleGenerateChart"
            >
                Generate Utilisation Chart
            </el-button>
        </el-row>
        <br/>
        <el-row>
            <!--journey requests table-->
            <el-col :span="24">
                <el-table
                        v-loading="isLoadingJourneyRequests"
                        :data="journeyRequests"
                        @selection-change="handleSelectionChange"
                >
                    <el-table-column
                            type="selection"
                            width="55"
                            :selectable="checkSelectable">
                    </el-table-column>
                    <el-table-column
                            prop="placeOriginName"
                            label="Origin"
                    ></el-table-column>
                    <el-table-column
                            prop="placeDestinationName"
                            label="Destination"
                    ></el-table-column>
                    <el-table-column
                            label="From"
                            align="center"
                    >
                        <template slot-scope="scope">
                            {{scope.row.start.format('Do MMM')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Until"
                            align="center"
                    >
                        <template slot-scope="scope">
                            {{scope.row.end.format('Do MMM')}}
                        </template>
                    </el-table-column>
                    <el-table-column label="Actions" align="center">
                        <template slot-scope="scope">
                            <!--first button-->
                            <el-button v-if="scope.row.processed" size="mini" type="primary" @click="handleShowJourneyRequestModal(scope.row)">Show</el-button>
                            <el-button v-else size="mini" type="primary" disabled>Processing...</el-button>
                            <!--second button-->
                            <el-button size="mini" type="danger" @click="handleDeleteJourneyRequest(scope.row)">Delete</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <journey-request-modal :user="user"></journey-request-modal>
        <capacity-utilisation-chart-modal></capacity-utilisation-chart-modal>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'
    import JourneyRequestModal from './JourneyRequestCarrier';
    import CapacityUtilisationChartModal from "../modals/CapacityUtilisationChart";

    export default {
        // Do not forget this little guy
        name: 'JourneyRequestsCarrier',
        // share common functionality with component mixins
        mixins: [],
        // compose new components
        extends: {},
        // component properties/variables
        props: {
            user: {
                required: true,
                type: Object,
            }
        },
        // variables
        data() {
            return {
                showAddModal: false,
                form: {
                    placeOriginId: '',
                    placeDestinationId: '',
                    time: [],
                },
                multipleSelection: [],
            }
        },
        computed: {
            ...mapState({
                journeyRequestsLoadStatus: state => state.journeyRequests.journeyRequestsLoadStatus,
                journeyRequestAddStatus: state => state.journeyRequests.journeyRequestAddStatus,
            }),
            ...mapGetters({
                places: 'getPlaces',
            }),
            ...mapGetters('journeyRequests', {
                journeyRequests: 'getJourneyRequests',
            }),
            isLoadingJourneyRequests() {
                return this.journeyRequestsLoadStatus === 1;
            },
            isAddingJourneyRequest() {
                return this.journeyRequestAddStatus === 1;
            },
            aRowIsProcessing() {
                const processeds = this.journeyRequests.map((row) => {
                    return row.processed;
                });
                return processeds.includes(false);
            },
            canGenerateChart() {
                return this.multipleSelection.length > 0;
            }
        },
        // when component uses other components
        components: {
            JourneyRequestModal,
            CapacityUtilisationChartModal,
        },
        // methods
        watch: {},
        methods: {
            checkSelectable(row) {
                return row.processed;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleGenerateChart() {
                const journeyRequestIds = this.multipleSelection.map(row => row.id);
                this.$store.dispatch('capacityUtilisationCharts/updateJourneyRequestIds', journeyRequestIds);
                this.$store.dispatch('capacityUtilisationCharts/updateDialogVisible', true);
            },
            handleOpenAddModal() {
                this.showAddModal = true;
            },
            handleCloseAddModal() {
                this.showAddModal = false;
            },
            handleShowJourneyRequestModal(journeyRequest) {
                this.$store.dispatch('journeyRequests/updateShowJourneyRequestModal', true);
                this.$store.dispatch('journeyRequests/loadJourneyRequest', journeyRequest.id)
                    .catch((error) => {
                        this.$message.error('Sorry, failed to load this journey request.');
                    });
            },
            handleDeleteJourneyRequest(journeyRequest) {
                this.$confirm(`Sure to delete the capacity report from ${journeyRequest.placeOriginName} to ${journeyRequest.placeDestinationName}?`, 'Confirm', {
                    type: 'warning',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = 'Deleting...';
                            this.deleteJourneyRequest(journeyRequest.id)
                                .catch(e => {
                                    console.log(e);
                                    this.$message.error('Failed to delete the capacity report.');
                                }).then(() => {
                                    instance.confirmButtonLoading = false;
                                    done();
                            })
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    this.$message.success('Deleted the capacity report successfully.')
                }).catch(() => {
                    //click cancel
                });
            },
            loadJourneyRequests() {
                this.$store.dispatch('journeyRequests/loadJourneyRequests')
                    .catch((error) => {
                        this.$message.error('Sorry, failed to load your journey requests.');
                    });
            },
            reloadJourneyRequests() {
                if (this.aRowIsProcessing) {
                    this.$store.dispatch('journeyRequests/reloadJourneyRequests')
                        .catch((error) => {
                            this.$message.error('Sorry, failed to reload your journey requests.');
                        });
                }
            },
            deleteJourneyRequest( id ) {
                return this.$store.dispatch('journeyRequests/deleteJourneyRequest', id);
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            },
            handleSubmit (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        const data = {
                            originPlaceId: this.form.placeOriginId,
                            destinationPlaceId: this.form.placeDestinationId,
                            startTime: this.form.time[0],
                            endTime: this.form.time[1],
                        };
                        //create a new capacity report
                        this.$store.dispatch('journeyRequests/addJourneyRequest', data)
                            .then(() => {
                                this.handleCloseAddModal();
                                this.$Message.success('Created a new capacity report successfully.');
                            }).catch(e => {
                                console.log(e);
                                this.$message.error('Sorry, failed to create a new capacity request.');
                            });
                    } else {
                        this.$message.error('Sorry, failed to validate the form.');
                    }
                })
            },
        },
        // component Lifecycle hooks
        mounted() {
            this.loadJourneyRequests();
            setInterval(() => {
                this.reloadJourneyRequests();
            }, 5000);
        },
    };
</script>

<style scoped>
    .el-form-item-inside {
        width: 85%;
    }
</style>